import { Box } from '@mui/material';
import Logo from 'components/LogoSign';

function AppInit() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%'
      }}>
      <Logo />
    </Box>
  );
}

export default AppInit;
